import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { ReactComponent as QuestionMark } from '../../../assets/images/question-mark.svg';
import { onChangeCityBoundariesOnlyActive, onChangePanoramasFilter } from '../../../ac/onChangeMapFilters';
import { PanoramasLegend } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const PanoramasFilterComponent = ({
    mapFilters,
    onChangePanoramasFilter,
    onChangeCityBoundariesOnlyActive,
}) => {
    return (
        <div>
            <div className={styles.checkboxIconGrid}>
                <span />
                <label htmlFor='city-boundaries-only-active'>{t`Только активные города`}</label>
                <div>
                    <label className={styles.switch}>
                        <input
                            type='checkbox'
                            id='city-boundaries-only-active'
                            checked={mapFilters.cityBoundariesOnlyActive}
                            onChange={onChangeCityBoundariesOnlyActive}
                        />
                        <span className={classnames(styles.sliderRound, styles.slider)} />
                    </label>
                </div>
                {
                    PanoramasLegend.map(({ value, color, label }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width='2vw'
                                height='2vw'
                                opacity='0.8'
                            />
                            <label htmlFor={label.id}>{i18n._(label)}</label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='poi'
                                        id={value}
                                        checked={mapFilters.panoramasStatuses.includes(value)}
                                        value={value}
                                        onChange={onChangePanoramasFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
            {mapFilters.panoramasStatuses.includes(PanoramasLegend[0].value) && (
                <div style={{ padding: '10px' }}>
                    <br />
                    <small>
                        <QuestionMark
                            style={{
                                width: '16px',
                                height: '16px',
                                verticalAlign: 'middle',
                                marginRight: '4px',
                            }}
                        />
                        {t`Нажмите на территорию в границах города, чтобы появился попап. Чем ближе к дороге - тем вероятнее получается нужная панорама.`}
                    </small>
                </div>
            )}
        </div>
    );
};
const mapStateToProps = ({ mapFilters, panoramasStatuses }) => ({ mapFilters, panoramasStatuses });
const ConnectedComponent = connect(
    mapStateToProps,
    { onChangePanoramasFilter, onChangeCityBoundariesOnlyActive }
)(PanoramasFilterComponent);
export const PanoramaFilter = withDisplayedLayersCheck(ConnectedComponent, t`Границы города`);
